import React from 'react';
import { escape } from 'lodash';

const placeholderWithFormatters = new RegExp(
  // eslint-disable-next-line no-template-curly-in-string
  '\\${[a-z0-9&_.\\[\\]\\:\\;\\-\\|]{1,256}}',
  'gi',
);

interface Props {
  text: string;
}

export function BdiWrapper(props: Props) {
  const wrappedText = escape(props.text || '').replace(
    placeholderWithFormatters,
    function (match) {
      return '<bdi>' + match + '</bdi>';
    },
  );
  return <span dangerouslySetInnerHTML={{ __html: wrappedText }} />;
}
